import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddProjectGroupSchedule, AddProjectSchedule, ScheduleEmail } from '@app/interfaces/lm/report-schedules';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportSchedulesService {
    private moduleApi = environment.api.services.lm;
    private baseUrl = this.moduleApi + '/report-schedules';

    constructor(private http: HttpClient) {}

    async getProjectReportSchedule(params: { projectId: string }): Promise<ScheduleEmail> {
        return lastValueFrom(this.http.get<ScheduleEmail>(`${this.baseUrl}/project-report-schedule`, {
            params: Object.assign(params)
        }));
    }

    async getProjectGroupReportSchedule(params: { projectGroupId: string }): Promise<ScheduleEmail> {
        return lastValueFrom(this.http.get<ScheduleEmail>(`${this.baseUrl}/project-group-report-schedule`, {
            params: Object.assign(params)
        }));
    }

    async addProjectReportSchedule(params: AddProjectSchedule): Promise<ScheduleEmail> {
        return lastValueFrom(this.http.post<ScheduleEmail>(`${this.baseUrl}/project-report-schedule`, params));
    }

    async addProjectGroupReportSchedule(params: AddProjectGroupSchedule): Promise<ScheduleEmail> {
        return lastValueFrom(this.http.post<ScheduleEmail>(`${this.baseUrl}/project-group-report-schedule`, params));
    }

    async settingEmail(params: {
        emailSender: string,
        emailPassword?: string,
        emailSmtpServer: string,
        title: string,
        html: string,
        recipients: string[]
    }): Promise<ScheduleEmail> {
        return lastValueFrom(this.http.post<ScheduleEmail>(`${this.moduleApi}/mail`, params));
    }
}
